export default {
  init() {

  },
  finalize() {
    const $popup = $('.popup-visitor-selector');

    if ($popup.length > 0) {
      // Show on scroll
      $(window).on('scroll', function() {

        if (!$popup.hasClass('done')) {
          $popup.addClass('show');
        }

      });

      // View more info
      $popup.find('.profile-information').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $popup.find('.popup-wrap').addClass('screen-b');
      });

      // Go back
      $popup.find('.popup-b-back').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $popup.find('.popup-wrap').removeClass('screen-b');
      });

      // I am a buyer
      $popup.find('.buyer-cta').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const url = $(this).attr('href');

        // Set the cookie accordingly
        const date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));

        const expiresTime = date.toUTCString();

        document.cookie = `visitor_pref=Buyer; expires=${expiresTime}; path=/`;

        if (url == '') {
          // Close the popup
          $popup.removeClass('show');
          $popup.addClass('done');
        } else {
          // Go to page
          window.location.replace(url);
        }
      });

      // I am a seller
      $popup.find('.seller-cta').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const url = $(this).attr('href');

        // Set the cookie accordingly
        const date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));

        const expiresTime = date.toUTCString();

        document.cookie = `visitor_pref=Seller; expires=${expiresTime}; path=/`;

        if (url == '') {
          // Close the popup
          $popup.removeClass('show');
          $popup.addClass('done');
        } else {
          // Go to page
          window.location.replace(url);
        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/popupVisitorSelector.js